import { useState } from "react";
import {
  Input, Select, RadioGroup, Radio, Stack, CheckboxGroup, Checkbox, Button, HStack,
} from "@chakra-ui/react";
import { FieldShell, type FieldControlProps } from "./FieldShell";
import type { FieldOption } from "../types";

export function SelectField({ field, fieldValue, onChange, showError, errMsg }: FieldControlProps) {
  const value = fieldValue?.value ?? "";
  const [extraOptions, setExtraOptions] = useState<FieldOption[]>([]);
  const options = [...(field.options ?? []), ...extraOptions];
  return (
    <FieldShell field={field} showError={showError} errMsg={errMsg}>
      <HStack>
        <Select
          placeholder="Selecione uma opção"
          value={value}
          onChange={(e) => onChange(field.id, e.target.value)}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </Select>
      </HStack>
      {field.allow_new_options && (
        <NewOptionInput
          onAdd={(label) => {
            setExtraOptions((prev) => [...prev, { value: label, label }]);
            onChange(field.id, label);
          }}
        />
      )}
    </FieldShell>
  );
}

export function MultiselectField({ field, fieldValue, onChange, showError, errMsg }: FieldControlProps) {
  const options = field.options ?? [];
  return (
    <FieldShell field={field} showError={showError} errMsg={errMsg}>
      <CheckboxGroup
        value={fieldValue?.value_options ?? []}
        onChange={(vals) => onChange(field.id, null, vals as string[])}
      >
        <Stack>
          {options.map((opt) => (
            <Checkbox key={opt.value} value={opt.value}>{opt.label}</Checkbox>
          ))}
        </Stack>
      </CheckboxGroup>
    </FieldShell>
  );
}

export function RadioField({ field, fieldValue, onChange, showError, errMsg }: FieldControlProps) {
  const value = fieldValue?.value ?? "";
  const options = field.options ?? [];
  return (
    <FieldShell field={field} showError={showError} errMsg={errMsg}>
      <RadioGroup value={value} onChange={(v) => onChange(field.id, v)}>
        <Stack>
          {options.map((opt) => (
            <Radio key={opt.value} value={opt.value}>{opt.label}</Radio>
          ))}
        </Stack>
      </RadioGroup>
    </FieldShell>
  );
}

export function BooleanField({ field, fieldValue, onChange, showError, errMsg }: FieldControlProps) {
  const value = fieldValue?.value ?? "";
  return (
    <FieldShell field={field} showError={showError} errMsg={errMsg}>
      <RadioGroup value={value} onChange={(v) => onChange(field.id, v)}>
        <Stack direction="row">
          <Radio value="true">Sim</Radio>
          <Radio value="false">Não</Radio>
        </Stack>
      </RadioGroup>
    </FieldShell>
  );
}

function NewOptionInput({ onAdd }: { onAdd: (label: string) => void }) {
  const [value, setValue] = useState("");
  return (
    <HStack mt={2}>
      <Input
        size="sm"
        placeholder="Adicionar nova opção"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <Button
        size="sm"
        onClick={() => {
          if (!value.trim()) return;
          onAdd(value.trim());
          setValue("");
        }}
      >
        +
      </Button>
    </HStack>
  );
}